import { Box, Image, Grid, Text } from "@chakra-ui/react"
import colors from "@constants/colors"
import Link from "@components/Link"
import Tag from "@components/universal/Tag"
import { getProductUrl } from "@utils/urls"

const DesktopProductList: React.FC<any> = ({
  containerRef,
  product,
  hasTags,
}) => {
  const { slug, tag, image, name, model, series, variants, price } = product
  return (
    <Grid
      overflow="auto"
      ref={containerRef}
      width="100%"
      // height="100px"
      gridTemplateColumns={
        hasTags ? "5fr 2fr 1fr 1fr 2fr 1fr" : "5fr 2fr 1fr 1fr 2fr"
      }
      gridColumnGap="2rem"
      alignItems="center"
      padding="0"
      textAlign="start"
      borderTop="1px solid #E9E9E9"
    >
      <Box
        margin="10px 0 10px 0"
        d="flex"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Link
          href={getProductUrl(slug)}
          useAnchor
          position="relative"
          w="100%"
          h="auto"
          maxWidth="100px"
          maxHeight="100px"
          minW="100px"
          overflow="hidden"
        >
          <Box flexShrink={0} position="relative" w="100%" h="100%">
            <Box w="100%" pb="100%" />
            {image && (
              <Image
                src={image}
                position="absolute"
                top="0px"
                left="0px"
                w="100%"
                h="100%"
                objectFit="contain"
                objectPosition="center center"
              />
            )}
          </Box>
        </Link>
        <Link href={getProductUrl(slug)} useAnchor width="100%">
          <Text pl="1rem">{name}</Text>
        </Link>
      </Box>
      <Text>{model}</Text>
      <Text>{`$${price}`}</Text>
      <Text as="span">{series}</Text>
      <Text as="span">{variants}</Text>
      {tag && (
        <Box>
          <Tag bg={colors.brand}>{`${tag}!`}</Tag>
        </Box>
      )}
    </Grid>
  )
}

export default DesktopProductList
